module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white-3ebc2a6eaf961f9129ec234f48b2d896.png";